
const Error404 = ()=>{
    return (
        <h1>Hello Error 404!</h1>
    )
} 

export default Error404